__turbopack_context__.v({
  "button": "TextInputCopy-module__mbNNWG__button",
  "container": "TextInputCopy-module__mbNNWG__container",
  "input": "TextInputCopy-module__mbNNWG__input",
});
